export default "__VITE_ASSET__DpGreT3f__"